import React , { useState }  from 'react'
import { Link } from 'react-router-dom';
import { Footer , Header} from '../index';
import './Administartion.css' ;
import Direction from './Direction';
import Scolarite from './Scolarite';
import Finance from './Finance';
import Bibliothèque from './Bibliothèque';
import Informatique from './Informatique';
import Guichet from './Guichet';

function Administration() {
  const [selectedTab, setSelectedTab] = useState('Direction');

const handleTabClick = (tabName) => {
  setSelectedTab(tabName);
};
  return (
    <>
      <Header/>
      <div className='containerIng  containerAdministration'> 
          <div className='bgtransport'>  </div>
          <div className='ligne'>  </div>

          <div className="container-fluid text-white text-center" style={{position:'relative',marginTop:'-200px',marginBottom:'100px'}}>
            <h2 style={{fontFamily:'fantasy', fontSize:'50px'}} >Administartion</h2>
          <p ><Link className='linkIng' to="/">Accueil</Link> <span>{'>'}</span> <Link className='linkIng'>Formation</Link> <span>{'>'}</span> <Link className='linkIng'
              to="/Administartion">Administartion</Link></p>
         </div>

         <div class="contentimagesAdministration">
            <div className='btnsAdministartion'>
              <button onClick={() => handleTabClick('Direction')} >Direction</button>
              <button onClick={() => handleTabClick('Scolarite')} >Scolarité</button>
              <button  onClick={() => handleTabClick('Finance')} >Finance</button>
              <button >Resources humaines</button>
              <button>Tirage</button>

              <button onClick={() => handleTabClick('Bibliothèque')}>Bibliothèque</button>
              <button>Bureau d'ordre</button>
              <button onClick={() => handleTabClick('Informatique')}>Informatique</button>
              <button onClick={() => handleTabClick('Guichet')}>Guichet</button>
              <button>Archivage</button>
            </div>
            {selectedTab === 'Direction' && <Direction />}
            {selectedTab === 'Scolarite' && <Scolarite />}
            {selectedTab === 'Finance' && <Finance />}
            {selectedTab === 'Bibliothèque' && <Bibliothèque />}
            {selectedTab === 'Informatique' && <Informatique />}
            {selectedTab === 'Guichet' && <Guichet />}




          </div>

        </div>
        <Footer/>
    
    </>
  )
}

export default Administration